import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// components
import Header from "./components/Header";
import Footer from "./components/Footer";
// pages
import DestructionFormPage from "./pages/Destruction";
import LimitedWarranty from "./pages/LimitedWarranty";
import Wastage from "./pages/Wastage";
import Dosing from "./pages/Dosing";
import Login from "./pages/admin/Login";
import AdminRoute from "./pages/admin/AdminRoute";
import BrowseRecords from "./pages/admin/BrowseRecords";
import RecordDetail from "./pages/admin/RecordDetail";
// styles
import "./App.css";

const { detect } = require("detect-browser");
const browser = detect();

export default function App() {
  if (browser && browser.name) {
    if (browser.name === "ie") {
      return (
        <div className="App" style={{ textAlign: "center", marginTop: 50 }}>
          <h1>We're sorry, but your browser isn't supported</h1>
          <p>
            To view this page please try using a newer browser like Chrome,
            Firefox, Safari, or Edge.
          </p>
          <a href="#" onClick={() => window.history.back()}>
            Go Back
          </a>
        </div>
      );
    }
  }

  const isDosing = window.location.hostname.indexOf("dosing") !== -1;
  return (
    <div className="App">
      <Router>
        <Header />
        <div className="container">
          <Switch>
            <Route
              path={"/limited_warranty"}
              component={LimitedWarranty}
            ></Route>
            <Route path={"/wastage"} component={Wastage}></Route>
            <Route path={"/cert/:id"} component={DestructionFormPage}></Route>
            <Route path={"/login"} component={Login} />
            <Route path="/dosing" component={Dosing} />
            <Route path="/popup" />
            <AdminRoute
              path={"/admin/:form/:formId"}
              component={RecordDetail}
            />
            <AdminRoute path={"/admin/:form"} component={BrowseRecords} />
            <AdminRoute path={"/admin"} component={BrowseRecords} />
            <Route component={isDosing ? Dosing : LimitedWarranty}></Route>
          </Switch>
        </div>
        <Footer />
      </Router>
    </div>
  );
}
